import React,{useState} from 'react'




export default function TextForm(props) {
    
    const handleUpClick = () =>{
    
    let newText = text.toUpperCase();
    setText(newText)
    props.ShowAlert("Converted to upper case", "success")

    };
    const handleLowpClick = () =>{
    
        let newText = text.toLowerCase();
        setText(newText)
        props.ShowAlert("Converted to lower case", "success")
    
        };
    
    const handleOnchange = (event) =>{
        setText(event.target.value)
       


    };
    function convertCase(str) {
        let convertedString = '';
        for (let i = 0; i < str.length; i++) {
            const char = str[i];
            if (char === char.toUpperCase()) {
                // Convert uppercase to lowercase
                convertedString += char.toLowerCase();
            } else if (char === char.toLowerCase()) {
                // Convert lowercase to uppercase
                convertedString += char.toUpperCase();
            } else {
                // Leave non-alphabetic characters unchanged
                convertedString += char;
            }
        }
        return convertedString;
    }
    const handleInverse = () =>{
        let txt = convertCase(text);
        setText(txt)
        props.ShowAlert("Converted to Inversed case", "success")
        

    };
    const [copied,setCopied] = useState(false)
    const copybtn = ()=>{
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(()=> setCopied(false),2000)
        props.ShowAlert("SuccesFully copied", "success")
    }
    const handle = () =>{
        setText('')
        props.ShowAlert("SuccesFully cleared", "success")
    }

    function capitalizeWords(str) {
        // Split the string into an array of words
        let words = str.split(' ');
    
        // Iterate through the array and capitalize the first letter of each word
        for (let i = 0; i < words.length; i++) {
            words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        }
    
        // Join the words back into a single string and return
        return words.join(' ');
    }
    const handleFirstCapi = () =>{
        let txt = capitalizeWords(text);
        setText(txt)
        props.ShowAlert("Succes: first letter is Capitalized", "success")
    }
        
    const [text,setText] = useState('');
    const removeSpace = () =>{
        let tx = removeExtraSpaces(text);
        setText(tx);
        props.ShowAlert("Succesfully remove extra space", "success")
    }
    function removeExtraSpaces(str) {
        // Replace consecutive spaces with a single space using regular expression
        return str.replace(/\s+/g, ' ').trim();
    }
   
    // setText("fhdfhcghcfn ihyb")
    
  return (
    <>
    <div className="container">
        <h1 >{props.heading}</h1>
     
  <div className="form-group" style={{backgroundColor:props.mode==='dark'?'#13466e':'white',color:props.mode==='dark'?'white':'#042743'}}>
   
    <textarea type="text" className="form-control" id="Mybox" value={text} onChange={handleOnchange}  placeholder="Example input placeholder" rows="8" style={{backgroundColor:props.mode==='dark'?'#00215E':'white',color:props.mode==='dark'?'white':'black'}}  />
  </div>
   <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={handleUpClick}>Convert to Uppercase</button>
   <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={handleLowpClick}>Convert to Lowercase</button>
   <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={handle}>Clear text</button>
   <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={handleInverse}>Inversed </button>
   <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={copybtn}>Copy </button>
   <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={handleFirstCapi}>First Letter Capital </button>
   <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={removeSpace}>Remove extra space </button>
      
    </div>
    <div className="container my-3">
        <h2>Your text summary</h2>
        <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} words, {text.length} character</p>
        <p> {0.008 *text.split(" ").filter((element)=>{return element.length!==0}).length } Minutes read </p>
        <h2>Preview</h2>
        <p>{text.length>0?text:" your text is empty"}</p>

    </div>


    </>
  )
}
